<script lang="ts">
import type { SetupContext } from 'vue';
import { defineComponent } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import FieldErrorMessage from './FieldErrorMessage.vue';
import FieldUtil from './FieldUtil';

export default defineComponent({
  components: {
    FieldErrorMessage,
  },
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: String,
    },
  },
  setup(props: { modelValue: string; field: HekateDisplayField }, context: SetupContext) {
    const bubbleModel = FieldUtil.bubbleModel({
      get: () => props.modelValue,
      emitter: context,
    });

    return {
      bubbleModel,
    };
  },
});
</script>
<template>
  <div class="field-unsupported">
    <strong>Unsupported form field</strong>
    <p>{{ field.name }}</p>
    <input
      v-model="bubbleModel"
      type="text"
      :placeholder="field.htmlName"
    />
    <field-error-message :messages="[]" />
  </div>
</template>

<style lang="scss" scoped>
.field-unsupported {
  border: 8px color #eee;
}
</style>
